<template>
  <v-layout
    row
    justify-center
  >
    <confirm-dialog
      :dialog="!!confirmIdentCase"
      :confirm-btn-label="'Yes'"
      :cancel-btn-label="'No'"
      :head-text="'Confirm'"
      :description="'Ident case not found, Are you sure you want to import it?'"
      :processing="isLoading"
      :confirm-action="() => importIdent(confirmIdentCase, false)"
      :cancel-action="() => confirmIdentCase = null"
    />
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="import-ident">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              import_export
            </v-icon>
            <h3 class="title ml-2">
              Import ident case
              <span v-if="currentUser">
                for {{ currentUser.first_name }} {{ currentUser.last_name }}
              </span>
            </h3>
            <v-spacer />
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />
          <v-card-title class="toolbar grey lighten-5 secondary--text">
            <ident-user-search
              :on-user-select="onUserSelect"
              :is-loading-user-detail="isLoadingUserDetail"
              :current-user="currentUser"
            />
          </v-card-title>
          <v-card-text>
            <v-container
              grid-list-md
              class="pa-0"
            >
              <v-layout
                wrap
                class="form-group"
              >
                <v-flex xs12>
                  <h6 class="subheading">
                    Import details
                  </h6>
                </v-flex>

                <v-flex
                  v-if="!currentUser"
                  xs12
                  class="error--text"
                >
                  There is no user selected.
                </v-flex>

                <v-layout
                  v-else
                  wrap
                >
                  <!-- START POST IDENT / IDNOW FORMS -->
                  <import-ident-form-fields
                    ref="formFields"
                    :current-user="currentUser"
                    :on-submit="importIdent"
                  />
                </v-layout>
              </v-layout>
            </v-container>
            <v-alert
              v-if="error"
              :value="error"
              type="error"
              color="error"
            >
              {{ error }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="primary"
                  @click="submitFormFields"
                  v-on="on"
                >
                  <span>Import ident case</span>
                </v-btn>
              </template>
              <span>Validate and submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { countryCodesArray } from '@/enum/CountryCodesEnum';
import IdentUserSearch from '@/components/ident/shared/IdentUserSearch';
import ImportIdentFormFields from '@/components/ident/dialog/import/ImportIdentFormFields';
import ConfirmDialog from '../../../shared/ConfirmDialog';

export default {
  name: 'ImportIdentDialog',
  components: {
    IdentUserSearch,
    ImportIdentFormFields,
    ConfirmDialog,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },

    currentUser: {
      type: Object,
      default: null,
    },

    // ident-user-search component
    isLoadingUserDetail: {
      type: Boolean,
      required: true,
    },
    onUserSelect: {
      type: Function,
      required: true,
    },
  },


  data: () => ({
    countryCodesArray,
    isLoading: false,
    isLoadingUsers: false,
    error: null,
    userResults: [],
    confirmIdentCase: null,
  }),

  methods: {
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },

    submitFormFields() {
      this.$refs.formFields.submit();
    },

    async importIdent(postData = null, verifyIdent = true) {
      if (postData) {
        this.isLoading = true;

        if (verifyIdent) {
          try {
            await this.$store.dispatch('validateIdent', postData);
          } catch (error) {
            this.isLoading = false;
            this.confirmIdentCase = postData;

            return;
          }
        }
        this.confirmIdentCase = null;
        this.$store
          .dispatch('importIdent', postData)
          .then(({ data }) => {
            if (data) {
              console.info('importIdentIdent success', data);

              return this.$store
                .dispatch('fetchIdents', { userId: data.user_id })
                .then(() => this.onToggleOpen());
            }
            throw new Error(`Unable to import ${postData.provider} Ident case`);
          })
          .catch((err) => {
            this.error = err.response ? err.response.data.message : err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" >
.import-ident {
  .v-card__title {
    padding: 24px;
  }
  .v-card__text {
    max-height: 65vh;
    overflow: auto;
    padding-top: 32px;
  }
  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .radio-label {
    position: absolute;
    font-size: 16px;
    text-align: left;
    max-width: 133%;
    height: 20px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.54);
    -webkit-transform: translateY(-18px) scale(0.75);
    transform: translateY(0px) translateX(-6px) scale(0.75);
  }
  .subheading {
    padding: 8px;
    background: white;
    color: rgba(0, 0, 0, 0.54);
    top: -20px;
    left: 8px;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ident/dialog/import/ImportIdentDialog.vue